Wee.fn.make('cart', {
	init: function() {
		var context = 'cart',
			successMessage = 'Cart updated',
			genericErrorMessage = 'Something went wrong, please try again.';

		Wee.commerce.initCartTotals({
			model: $.get('cart')
		});

		Wee.commerce.initQtySelector({
			ajax: true,
			success: function(response) {
				Wee.flash.init({
					model: {
						success: response.success,
						message: successMessage,
						context: context
					}
				});
			},
			error: function(response) {
				Wee.flash.init({
					model: {
						error: true,
						message: response.error ? response.error : genericErrorMessage,
						context: context
					}
				});
			}
		});

		Wee.commerce.initRemoveItem({
			success: function(response) {
				if (! response.cart.isEmpty) {
					Wee.flash.init({
						model: {
							success: response.success,
							message: successMessage,
							context: context
						}
					});
				}
			},
			error: function(response) {
				Wee.flash.init({
					model: {
						error: true,
						message: response.error ? response.error : genericErrorMessage,
						context: context
					}
				});
			}
		});
	},
	unload: function() {
		Wee.flash.destroy();
		Wee.commerce.destroyQtySelector();
		Wee.commerce.destroyRemoveItem();
	}
});